import * as React from 'react';
import strings from '../../strings/strings.json';
import OrganisationForm from './components/OrganisationForm';
import { MainSectionWithGaps } from '../../components/sections/MainSection';
import Header from 'components/sections/Header';
import NavBackButton from 'components/buttons/NavBackButton';

export default function CreateOrganisationPage(): JSX.Element {
    return (
        <>
            <Header
                title={strings.organisationForm.title}
                aboveTitleElement={
                    <NavBackButton
                        backButtonTitle={strings.updateOrganisationPage.backButtonTitle}
                        backButtonAria={strings.updateOrganisationPage.backButtonTitleAria}
                        backButtonHref={'/admin/dashboard'}
                    />
                }
            />
            <MainSectionWithGaps>
                <OrganisationForm />
            </MainSectionWithGaps>
        </>
    );
}
